<template>
  <section
    :data-component-name="$options.name"
    class="row section-sansTheme section-page be_section mx-0"
    :class="[jel_getClassObject(content), content.sectionCoinRondTop ? 'be_coin_rond' : '']"
  >
    <hr class="barre_entete" />
    <b-img-lazy
      v-if="imageEntete"
      :src="jel_getFichierSrc(imageEntete)"
      class="flex-shrink-0"
      :alt="content.title"
    />
    <h1 v-if="content.title" class="be_titre graphik_bold" :style="{ color: content.titleColor }">
      {{ content.title }}
    </h1>
    <p v-if="content.title2" class="be_sous_titre mt-lg-1">
      {{ content.title2 }}
    </p>
  </section>
</template>

<script>
import { isJelMobile } from '@/helpers/AppHelpers';

export default {
  name: 'BingoEntete',
  props: {
    content: { type: Object, required: true },
  },
  computed: {
    imageEntete() {
      // Vérification si nous sommes en mode mobile
      if (isJelMobile && (this.$mq == 'sm' || this.$mq == 'xs')) {
        // si une image mobile est défini la retourne sinon on retourne null
        if (this.content.imageMobile) {
          return this.content.imageMobile;
        }
        return null;
      }

      // Vérification si une image desktop existe
      if (this.content.image) {
        // une image desktop est définie, on la retourne
        return this.content.image;
      }

      // aucune image desktop n'est définie, on retourne null autrement le lazyImage fait un 404
      return null;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.jel_setCookieAffichage(this.content); // nextTick obligatoire
    });
  },
};
</script>

<style lang="scss" scoped>
.contenu {
  background-position: center;
  background-repeat: no-repeat;
}
.contenu.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

.barre_entete {
  border: 0.6rem solid rgb(13, 203, 143);
  width: 100%;
  margin: 0;
}

.be_section {
  overflow-x: hidden;
  padding-left: 0px;
}
.be_titre {
  position: absolute;
  top: 10%;
  left: 20%;
  @include ms-respond(font-size, 4);
}

.be_sous_titre {
  position: absolute;
  top: 45%;
  @include ms-respond(font-size, 1);
  margin-left: 25%;
  color: #808080;
}
.be_coin_rond {
  border-top-left-radius: ms(3);
  border-top-right-radius: ms(3);
}

@include media-breakpoint-only(md) {
  .be_titre {
    text-align: center;
    margin-left: 0;
    width: 100%;
    left: 0;
  }

  .be_sous_titre {
    text-align: center;
    margin-left: 0;
    width: 100%;
    left: 0;
  }
}

@media screen and (max-width: 765px) {
  .be_section {
    margin-bottom: 2rem;
  }

  .be_titre {
    text-align: center;
    margin-left: 0;
    width: 100%;
    left: 0;
  }

  .be_sous_titre {
    text-align: center;
    margin-left: 0;
    width: 100%;
    left: 0;
    top: 60%;
  }

  .barre_entete {
    border-width: 0.4rem;
    width: 100%;
    margin: 0;
  }
}
</style>
